import React from "react";
import { MapPin, ArrowRight } from "@phosphor-icons/react";
import { useLang } from "../i18n/LanguageContext";
import SEO from "../components/SEO";

const Careers = () => {
  const { t } = useLang();
  const roles = [
    { title: t.careers.role1, loc: t.careers.role1Loc },
    { title: t.careers.role2, loc: t.careers.role2Loc },
    { title: t.careers.role3, loc: t.careers.role3Loc },
  ];

  return (
    <>
      <SEO
        title="Careers"
        description="Build a career with Masika Chem SARL — open roles in sales, logistics and technical support across the DRC's mining sector."
        path="/careers"
      />

      <section className="bg-white border-b border-neutral-200" data-testid="careers-hero">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <div className="inline-flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-[#C8102E]" />
              <span className="text-[11px] font-bold tracking-[0.3em] uppercase text-[#C8102E]">
                {t.careers.overline}
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-neutral-900">
              {t.careers.title}
            </h1>
          </div>
          <div className="md:col-span-5 flex items-end">
            <p className="text-lg text-neutral-600 leading-relaxed">{t.careers.sub}</p>
          </div>
        </div>
      </section>

      <section className="bg-[#F7F7F5] py-20" data-testid="careers-roles">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-10">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-2xl font-extrabold tracking-tight">{t.careers.openTitle}</h2>
            <span className="text-xs font-bold tracking-[0.25em] uppercase text-neutral-500">
              {roles.length} OPEN
            </span>
          </div>

          <div className="bg-white border border-neutral-200">
            {roles.map((r, i) => (
              <a
                key={i}
                href={`mailto:sales@masikachem.com?subject=Application: ${encodeURIComponent(r.title)}`}
                data-testid={`career-role-${i}`}
                className="group grid grid-cols-12 items-center gap-4 px-6 py-6 border-b border-neutral-100 last:border-b-0 hover:bg-neutral-50 transition-colors"
              >
                <div className="col-span-12 md:col-span-7">
                  <h3 className="text-lg md:text-xl font-bold text-neutral-900 group-hover:text-[#C8102E]">
                    {r.title}
                  </h3>
                </div>
                <div className="col-span-7 md:col-span-3 flex items-center gap-2 text-sm text-neutral-600">
                  <MapPin size={16} className="text-[#C8102E]" /> {r.loc}
                </div>
                <div className="col-span-5 md:col-span-2 flex justify-end">
                  <span className="inline-flex items-center gap-1 text-xs font-bold text-[#C8102E]">
                    {t.careers.apply} <ArrowRight size={12} weight="bold" />
                  </span>
                </div>
              </a>
            ))}
          </div>

          <p className="mt-6 text-xs text-neutral-500">
            Spontaneous applications: <a className="text-[#C8102E] font-semibold" href="mailto:sales@masikachem.com">sales@masikachem.com</a>
          </p>
        </div>
      </section>
    </>
  );
};

export default Careers;
